import styled from 'styled-components'
import { Range } from 'react-range'
import Icon from '../Icon'

type SliderProps = {
  increment: number
  range: {
    min: number
    max: number
    step: number
  }
  showControls?: boolean
  value: number
  width?: string
  onChange: (value: number) => void
}

const Slider = ({ increment, range, showControls = true, value, width = '100%', onChange }: SliderProps) => {
  const onControlClick = (increased: boolean) => {
    let val = value
    if (increased && val < range.max) {
      val = value + increment
    } else if (!increased && val > range.min) {
      val = value - increment
    }
    onChange(val)
  }

  const canDecrease = value > range.min
  const canIncrease = value < range.max

  return (
    <SliderWrapper>
      {showControls && (
        <ControlIcon
          color={canDecrease ? 'gray5' : 'gray4'}
          icon="minus"
          onClick={() => onControlClick(false)}
          disabled={!canDecrease}
        />
      )}
      <RangeContainer width={width}>
        <Range
          step={range.step}
          min={range.min}
          max={range.max}
          values={[value]}
          onChange={(values) => onChange(values[0])}
          renderTrack={({ props, children }) => <RangeTrack {...props}>{children}</RangeTrack>}
          renderThumb={({ props }) => <RangeThumb {...props} />}
        />
      </RangeContainer>
      {showControls && (
        <ControlIcon
          color={canIncrease ? 'gray5' : 'gray4'}
          icon="plus"
          onClick={() => onControlClick(true)}
          disabled={!canIncrease}
        />
      )}
    </SliderWrapper>
  )
}

const SliderWrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${(p) => p.theme.colors.gray5};
  justify-content: center;
  width: 100%;
`

const ControlIcon = styled(Icon)<{ disabled?: boolean }>`
  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')} !important;
  display: inline-block;
`

const RangeContainer = styled.div<{ width?: string }>`
  margin: 30px 20px;
  width: ${(p) => p.width};
`

const RangeTrack = styled.div`
  background-color: ${(p) => p.theme.colors.gray3};
  height: 3px;
  width: 100%;
`

const RangeThumb = styled.div`
  border-radius: 50%;
  background-color: ${(p) => p.theme.colors.gray7};
  height: 20px;
  width: 20px;
  outline: none;
`

export default Slider
